import { EVENT_CATEGORIES, HIT_TYPE, EVENT_NAMES } from 'app-webtech-core/beacon/const';

/**
 * Fires when the app loaded successfully after the App is launched at the start of a session.
 * Fires after the UI has loaded AND one of the following is satisfied
 * • On Live TV: the first clip starts playing, OR
 * • On VOD and MyPluto: the full page is completely loaded with images
 */
export const appLoadedBeacon = ({ payload }) => ({
  hitType: HIT_TYPE.EVENT,
  eventCategory: EVENT_CATEGORIES.LAUNCH,
  eventName: EVENT_NAMES.APP_LOADED,
  section: payload.section,
  previousSection: payload.previousSection,
});
